module.exports = __webpack_public_path__ + "img/logo-headline65x400.be9c769f.png";